






























import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Types
import { IProduct } from "@/models/products";
import { IProductConfigProviderData } from "@/models/providers/products";

@Component
export default class ProductDetails extends Vue {
  // Inject

  @Inject({ from: "productConfigProviderData" })
  public readonly $productConfigProviderData!: () => IProductConfigProviderData;

  public get $productConfigData() {
    return this.$productConfigProviderData();
  }

  // Prop

  @Prop({ required: true })
  public product!: IProduct;

  @Prop({ default: false })
  public readMore!: boolean;

  @Prop({ default: false })
  public showFreeTrial!: boolean;

  // Computed

  public get description() {
    return (
      this.product.description_translated ||
      this.product.description ||
      this.product.short_description_translated ||
      this.product.short_description
    );
  }

  public get name() {
    return this.product.name_translated || this.product.name;
  }
}
